var map = {
	"./1-draw.png": "b4c8",
	"./1-noparticipated.png": "3133",
	"./1-participated.png": "bc23",
	"./2-draw.png": "3676",
	"./2-noparticipated.png": "cc9c",
	"./2-participated.png": "3190",
	"./3-draw.png": "f8eb",
	"./3-noparticipated.png": "26a7",
	"./3-participated.png": "a91a",
	"./avatar.png": "32be",
	"./background.png": "5637",
	"./background2.png": "6e9c",
	"./click.png": "e677",
	"./noavatar.png": "300d",
	"./noprize.png": "3ffb",
	"./prize.png": "4ef3",
	"./rule.png": "31f9",
	"./sign.png": "1ff3",
	"./title.png": "a403"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e8f";